/** GB/T 2260 地级市坐标（GCJ-02，来源 DataV 区域中心点） */
export const CITY_CODE_TO_COORDS = {
	"110000": [116.405285, 39.904989],
	"120000": [117.190182, 39.125596],
	"130100": [114.502461, 38.045474],
	"130200": [118.175393, 39.635113],
	"130300": [119.586579, 39.942531],
	"130400": [114.490686, 36.612273],
	"130500": [114.508851, 37.0682],
	"130600": [115.482331, 38.867657],
	"130700": [114.884091, 40.811901],
	"130800": [117.939152, 40.976204],
	"130900": [116.857461, 38.310582],
	"131000": [116.704441, 39.523927],
	"131100": [115.665993, 37.735097],
	"140100": [112.549248, 37.857014],
	"140200": [113.295259, 40.09031],
	"140300": [113.583285, 37.861188],
	"140400": [113.113556, 36.191112],
	"140500": [112.851274, 35.497553],
	"140600": [112.433387, 39.331261],
	"140700": [112.736465, 37.696495],
	"140800": [111.003957, 35.022778],
	"140900": [112.733538, 38.41769],
	"141000": [111.517973, 36.08415],
	"141100": [111.134335, 37.524366],
	"150100": [111.670801, 40.818311],
	"150200": [109.840405, 40.658168],
	"150300": [106.825563, 39.673734],
	"150400": [118.956806, 42.275317],
	"150500": [122.263119, 43.617429],
	"150600": [109.99029, 39.817179],
	"150700": [119.758168, 49.215333],
	"150800": [107.416959, 40.757402],
	"150900": [113.114543, 41.034126],
	"210100": [123.429096, 41.796767],
	"210200": [121.618622, 38.91459],
	"210300": [122.995632, 41.110626],
	"210400": [123.921109, 41.875956],
	"210500": [123.770519, 41.297909],
	"210600": [124.383044, 40.124296],
	"210700": [121.135742, 41.119269],
	"210800": [122.235151, 40.667432],
	"210900": [121.648962, 42.011796],
	"211000": [123.18152, 41.269402],
	"211100": [122.06957, 41.124484],
	"211200": [123.844279, 42.290585],
	"211300": [120.451176, 41.576758],
	"211400": [120.856394, 40.755572],
	"220100": [125.3245, 43.886841],
	"220200": [126.55302, 43.843577],
	"220300": [124.370785, 43.170344],
	"220400": [125.145349, 42.902692],
	"220500": [125.936501, 41.721177],
	"220600": [126.427839, 41.942505],
	"220700": [124.823608, 45.118243],
	"220800": [122.841114, 45.619026],
	"230100": [126.642464, 45.756967],
	"230200": [123.95792, 47.342081],
	"230300": [130.975966, 45.300046],
	"230400": [130.277487, 47.332085],
	"230500": [131.157304, 46.643442],
	"230600": [125.11272, 46.590734],
	"230700": [128.899396, 47.724775],
	"230800": [130.361634, 46.809606],
	"230900": [131.015584, 45.771266],
	"231000": [129.618602, 44.582962],
	"231100": [127.499023, 50.249585],
	"231200": [126.99293, 46.637393],
	"310000": [121.472644, 31.231706],
	"320100": [118.767413, 32.041544],
	"320200": [120.301663, 31.574729],
	"320300": [117.184811, 34.261792],
	"320400": [119.946973, 31.772752],
	"320500": [120.619585, 31.299379],
	"320600": [120.864608, 32.016212],
	"320700": [119.178821, 34.600018],
	"320800": [119.021265, 33.597506],
	"320900": [120.139998, 33.377631],
	"321000": [119.421003, 32.393159],
	"321100": [119.452753, 32.204402],
	"321200": [119.915176, 32.484882],
	"321300": [118.275162, 33.963008],
	"330100": [120.153576, 30.287459],
	"330200": [121.549792, 29.868388],
	"330300": [120.672111, 28.000575],
	"330400": [120.750865, 30.762653],
	"330500": [120.102398, 30.867198],
	"330600": [120.582112, 29.997117],
	"330700": [119.649506, 29.089524],
	"330800": [118.87263, 28.941708],
	"330900": [122.106863, 30.016028],
	"331000": [121.428599, 28.661378],
	"331100": [119.921786, 28.451993],
	"340100": [117.283042, 31.86119],
	"340200": [118.376451, 31.326319],
	"340300": [117.363228, 32.939667],
	"340400": [117.018329, 32.647574],
	"340500": [118.507906, 31.689362],
	"340600": [116.794664, 33.971707],
	"340700": [117.816576, 30.929935],
	"340800": [117.043551, 30.50883],
	"341000": [118.317325, 29.709239],
	"341100": [118.316264, 32.303627],
	"341200": [115.819729, 32.896969],
	"341300": [116.984084, 33.633891],
	"341500": [116.507676, 31.752889],
	"341600": [115.782939, 33.869338],
	"341700": [117.489157, 30.656037],
	"341800": [118.757995, 30.945667],
	"350100": [119.306239, 26.075302],
	"350200": [118.11022, 24.490474],
	"350300": [119.007558, 25.431011],
	"350400": [117.635001, 26.265444],
	"350500": [118.589421, 24.908853],
	"350600": [117.661801, 24.510897],
	"350700": [118.178459, 26.635627],
	"350800": [117.02978, 25.091603],
	"350900": [119.527082, 26.65924],
	"360100": [115.892151, 28.676493],
	"360200": [117.214664, 29.29256],
	"360300": [113.852186, 27.622946],
	"360400": [115.992811, 29.712034],
	"360500": [114.930835, 27.810834],
	"360600": [117.033838, 28.238638],
	"360700": [114.940278, 25.85097],
	"360800": [114.986373, 27.111699],
	"360900": [114.391136, 27.8043],
	"361000": [116.358351, 27.98385],
	"361100": [117.971185, 28.44442],
	"370100": [117.000923, 36.675807],
	"370200": [120.355173, 36.082982],
	"370300": [118.047648, 36.814939],
	"370400": [117.557964, 34.856424],
	"370500": [118.66471, 37.434564],
	"370600": [121.391382, 37.539297],
	"370700": [119.107078, 36.70925],
	"370800": [116.587245, 35.415393],
	"370900": [117.129063, 36.194968],
	"371000": [122.116394, 37.509691],
	"371100": [119.461208, 35.428588],
	"371300": [118.326443, 35.065282],
	"371400": [116.307428, 37.453968],
	"371500": [115.980367, 36.456013],
	"371600": [118.016974, 37.383542],
	"371700": [115.469381, 35.246531],
	"410100": [113.665412, 34.757975],
	"410200": [114.341447, 34.797049],
	"410300": [112.434468, 34.663041],
	"410400": [113.307718, 33.735241],
	"410500": [114.352482, 36.103442],
	"410600": [114.295444, 35.748236],
	"410700": [113.883991, 35.302616],
	"410800": [113.238266, 35.23904],
	"410900": [115.041299, 35.768234],
	"411000": [113.826063, 34.022956],
	"411100": [114.026405, 33.575855],
	"411200": [111.194099, 34.777338],
	"411300": [112.540918, 32.999082],
	"411400": [115.650497, 34.437054],
	"411500": [114.075031, 32.123274],
	"411600": [114.649653, 33.620357],
	"411700": [114.024736, 32.980169],
	"420100": [114.298572, 30.584355],
	"420200": [115.077048, 30.220074],
	"420300": [110.787916, 32.646907],
	"420500": [111.290843, 30.702636],
	"420600": [112.144146, 32.042426],
	"420700": [114.890593, 30.396536],
	"420800": [112.204251, 31.03542],
	"420900": [113.926655, 30.926423],
	"421000": [112.23813, 30.326857],
	"421100": [114.879365, 30.447711],
	"421200": [114.328963, 29.832798],
	"421300": [113.37377, 31.717497],
	"430100": [112.982279, 28.19409],
	"430200": [113.151737, 27.835806],
	"430300": [112.944052, 27.82973],
	"430400": [112.607693, 26.900358],
	"430500": [111.46923, 27.237842],
	"430600": [113.132855, 29.37029],
	"430700": [111.691347, 29.040225],
	"430800": [110.479921, 29.127401],
	"430900": [112.355042, 28.570066],
	"431000": [113.032067, 25.793589],
	"431100": [111.608019, 26.434516],
	"431200": [109.97824, 27.550082],
	"431300": [112.008497, 27.728136],
	"440100": [113.280637, 23.125178],
	"440200": [113.591544, 24.801322],
	"440300": [114.085947, 22.547],
	"440400": [113.553986, 22.224979],
	"440500": [116.708463, 23.37102],
	"440600": [113.122717, 23.028762],
	"440700": [113.094942, 22.590431],
	"440800": [110.364977, 21.274898],
	"440900": [110.919229, 21.659751],
	"441200": [112.472529, 23.051546],
	"441300": [114.412599, 23.079404],
	"441400": [116.117582, 24.299112],
	"441500": [115.364238, 22.774485],
	"441600": [114.697802, 23.746266],
	"441700": [111.975107, 21.859222],
	"441800": [113.051227, 23.685022],
	"441900": [113.746262, 23.046237],
	"442000": [113.382391, 22.521113],
	"445100": [116.632301, 23.661701],
	"445200": [116.355733, 23.543778],
	"445300": [112.044439, 22.929801],
	"450100": [108.320004, 22.82402],
	"450200": [109.411703, 24.314617],
	"450300": [110.299121, 25.274215],
	"450400": [111.297604, 23.474803],
	"450500": [109.119254, 21.473343],
	"450600": [108.345478, 21.614631],
	"450700": [108.624175, 21.967127],
	"450800": [109.602146, 23.0936],
	"450900": [110.154393, 22.63136],
	"451000": [106.616285, 23.897742],
	"451100": [111.552056, 24.414141],
	"451200": [108.062105, 24.695899],
	"451300": [109.229772, 23.733766],
	"451400": [107.353926, 22.404108],
	"460100": [110.33119, 20.031971],
	"460200": [109.508268, 18.247872],
	"460300": [112.34882, 16.831039],
	"460400": [109.576782, 19.517486],
	"500000": [106.504962, 29.533155],
	"510100": [104.065735, 30.659462],
	"510300": [104.773447, 29.352765],
	"510400": [101.716007, 26.580446],
	"510500": [105.443348, 28.889138],
	"510600": [104.398651, 31.127991],
	"510700": [104.741722, 31.46402],
	"510800": [105.829757, 32.433668],
	"510900": [105.571331, 30.513311],
	"511000": [105.066138, 29.58708],
	"511100": [103.761263, 29.582024],
	"511300": [106.082974, 30.795281],
	"511400": [103.831788, 30.048318],
	"511500": [104.630825, 28.760189],
	"511600": [106.633369, 30.456398],
	"511700": [107.502262, 31.209484],
	"511800": [103.001033, 29.987722],
	"511900": [106.753669, 31.858809],
	"512000": [104.641917, 30.122211],
	"520100": [106.713478, 26.578343],
	"520200": [104.846743, 26.584643],
	"520300": [106.937265, 27.706626],
	"520400": [105.932188, 26.245544],
	"520500": [105.28501, 27.301693],
	"520600": [109.191555, 27.718346],
	"530100": [102.712251, 25.040609],
	"530300": [103.797851, 25.501557],
	"530400": [102.543907, 24.350461],
	"530500": [99.167133, 25.111802],
	"530600": [103.717216, 27.336999],
	"530700": [100.233026, 26.872108],
	"530800": [100.972344, 22.777321],
	"530900": [100.08697, 23.886567],
	"540100": [91.132212, 29.660361],
	"540200": [88.885148, 29.267519],
	"540300": [97.178452, 31.136875],
	"540400": [94.362348, 29.654693],
	"540500": [91.766529, 29.236023],
	"540600": [92.060214, 31.476004],
	"610100": [108.948024, 34.263161],
	"610200": [108.979608, 34.916582],
	"610300": [107.14487, 34.369315],
	"610400": [108.705117, 34.333439],
	"610500": [109.502882, 34.499381],
	"610600": [109.49081, 36.596537],
	"610700": [107.028621, 33.077668],
	"610800": [109.741193, 38.290162],
	"610900": [109.029273, 32.6903],
	"611000": [109.939776, 33.868319],
	"620100": [103.823557, 36.058039],
	"620200": [98.277304, 39.786529],
	"620300": [102.187888, 38.514238],
	"620400": [104.173606, 36.54568],
	"620500": [105.724998, 34.578529],
	"620600": [102.634697, 37.929996],
	"620700": [100.455472, 38.932897],
	"620800": [106.684691, 35.54279],
	"620900": [98.510795, 39.744023],
	"621000": [107.638372, 35.734218],
	"621100": [104.626294, 35.579578],
	"621200": [104.929379, 33.388598],
	"630100": [101.778916, 36.623178],
	"630200": [102.10327, 36.502916],
	"640100": [106.278179, 38.46637],
	"640200": [106.376173, 39.01333],
	"640300": [106.199409, 37.986165],
	"640400": [106.285241, 36.004561],
	"640500": [105.189568, 37.514951],
	"650100": [87.617733, 43.792818],
	"650200": [84.873946, 45.595886],
	"650400": [89.184078, 42.947613],
	"650500": [93.51316, 42.833248],
};

export const getCityGeoCoord = (code) => {
	if (!code) return null;
	const key = String(code);
	return CITY_CODE_TO_COORDS[key] ?? null;
};
